import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowLeftRightOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m10.111 7.308.99.99 3.9-3.899L11.1.5l-.99.99 2.21 2.21H2.091v1.4H12.32z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 11.601 4.9 15.5l.989-.99-2.209-2.209h10.228v-1.4H3.68l2.209-2.209-.99-.99z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowLeftRightOutlinedSize16Glyph.displayName = 'ArrowLeftRightOutlinedSize16Glyph';
